import { render, staticRenderFns } from "./tipostarea.vue?vue&type=template&id=585ec2f0&scoped=true"
import script from "./tipostarea.vue?vue&type=script&lang=js"
export * from "./tipostarea.vue?vue&type=script&lang=js"
import style0 from "./tipostarea.vue?vue&type=style&index=0&id=585ec2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ec2f0",
  null
  
)

export default component.exports